import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { LoadingButton } from "@mui/lab";
import bankidImage from "@repo/ui/assets/images/bankid.jpg";
import i18n from "i18next";
import { type FC } from "react";
import { LoginButtonType } from "./loginEnums";
import useLogin from "./useLogin";

export type ILoginButton = {
    journey: LoginButtonType;
};

// css styles for different variants
const variantByJourney = {
    [LoginButtonType.BankId]: "bank-id-text-only",
    [LoginButtonType.LocalLogin]: "contained",
    [LoginButtonType.LocalRegistration]: "contained",
} as const;

const labelByJourney = {
    [LoginButtonType.BankId]: i18n.t("crossroad.bankIdButton"),
    [LoginButtonType.LocalLogin]: "Přihlásit se",
    [LoginButtonType.LocalRegistration]: "Zaregistrovat se",
} as const;

export const LoginButton: FC<ILoginButton> = ({ journey, ...rest }) => {
    const { click, isDisabled } = useLogin(journey);
    const { inProgress } = useMsal();

    const loading = inProgress !== InteractionStatus.None;
    return (
        <LoadingButton
            {...rest}
            onClick={click}
            disabled={isDisabled}
            variant={loading && journey === LoginButtonType.BankId ? "contained" : variantByJourney[journey]}
            size={journey === LoginButtonType.BankId ? "small" : "large"}
            underline="none"
            disableElevation
            loading={loading}
            style={{
                minHeight: "51px",
            }}
        >
            {journey === LoginButtonType.BankId && (
                <img
                    src={bankidImage}
                    alt="BankiD"
                    style={{
                        height: "32px",
                        marginRight: "10px",
                        objectFit: "cover",
                        overflow: "auto",
                    }}
                />
            )}
            {labelByJourney[journey]}
        </LoadingButton>
    );
};
